import type { CourseModule } from "@/core/types";
import { lektionBildEinfuegen } from "./lektion-01-einfuegen";
import { lektionZuschneiden } from "./lektion-02-zuschneiden";
import { lektionFormen } from "./lektion-03-formen";

export const modulBilder: CourseModule = {
  id: "bilder",
  title: "Bilder und Formen",
  summary:
    "Bilder über den Platzhalter einbinden, proportional skalieren und im Folienrand " +
    "halten – und Zusammenhänge mit Formen und SmartArt zeigen, statt sie zu beschreiben.",
  level: "Grundlagen",
  lessons: [lektionBildEinfuegen, lektionZuschneiden, lektionFormen],
};
